// extracted by mini-css-extract-plugin
export default {"content":"DetailBank_content__+atgM"};